import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import CitationCell from '@Components/Results/substances/tables/cells/citation-cell.component.jsx';
import DataCell from '@Components/Results/substances/tables/cells/data-cell.component.jsx';
import PaureusCell from '@Components/Results/substances/tables/cells/paureus-cell.component.jsx';
import TargetCell from '@Components/Results/substances/tables/cells/target-cell.component.jsx';
import ParameterCell from '@Components/Results/substances/tables/cells/parameter-cell.component.jsx';

const cellContentRenderers = {
  paureus: value => <PaureusCell value={value} />,
  targets: (value, metadata) => <TargetCell metadata={metadata} value={value} />,
  citation: (citations, metadata) => <CitationCell metadata={metadata} citations={citations} />,
  citations: (citations, metadata) => <CitationCell metadata={metadata} citations={citations} />,
  parameter: (data, metadata, measurements) => <ParameterCell data={data} measurements={measurements} />,
};

export default class SubstanceQuantitativeCell extends React.PureComponent {

  render() {
    const { metadata, header, data = [''], measurements } = this.props;
    let contentRenderer = cellContentRenderers[header.id] || (data => <DataCell data={data} />);

    return (
      <td className={`column-${header.cssid} ${header.id === 'paureus' ? 'px-data__container' : ''}`}>
        {contentRenderer(data, metadata, measurements)}
      </td>
    );
  }
}

SubstanceQuantitativeCell.propTypes = {
  metadata: MetadataPropTypesShape,
  header: PropTypes.shape({
    id: PropTypes.string.isRequired,
    cssid: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  measurements: PropTypes.string,
};
